import { LocalShipping as LocalShippingIcon } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

interface DeliveryPositionProps {
  deliveryPosition?: number | null
  totalDeliveries?: number | null
  currentDriverDelivery?: number | null
  isMobile?: boolean
}

const containerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  p: 2,
  borderBottom: '2px solid #F6F4F4',
}

const iconStyles = {
  fontSize: '20px',
  color: '#666',
}

const textStyles = {
  fontSize: '14px',
  color: '#333',
}

export const DeliveryPosition = ({
  deliveryPosition,
  totalDeliveries,
  currentDriverDelivery,
  isMobile = false,
}: DeliveryPositionProps) => {
  if (!deliveryPosition || !totalDeliveries) return null

  return (
    <Box sx={containerStyles}>
      <LocalShippingIcon sx={iconStyles} />
      <Typography variant='body2' sx={isMobile ? { ...textStyles, fontWeight: 600 } : textStyles}>
        Your address is delivery number {deliveryPosition} on this route.
        {currentDriverDelivery != null && ` The driver is currently on delivery ${currentDriverDelivery}.`}
      </Typography>
    </Box>
  )
}
